module.exports = __webpack_public_path__ + "img/message.f44176d0.svg";